<app-organizer-shared-layout-dashboard [hasHeader]="hasHeader">
  <button
    *ngIf="haveIncompleteFields"
    app-vtmn-play-icon-button
    type="button"
    class="flex items-center justify-center w-6 h-6 text-3xl mb-3 -ml-2 lg:m-0"
    [type]="ctaButtonType.Button"
    [variant]="vtmnPlayIconButtonVariant.TERTIARY"
    [attr.aria-label]="'a11y.organizer.edit_activity.listing.back' | translate"
    (click)="confirmationModal.show()"
  >
    <vtmn-play-icon [name]="iconType?.ArrowLeft"></vtmn-play-icon>
  </button>

  <a
    *ngIf="!haveIncompleteFields"
    app-vtmn-play-icon-button
    [routerLink]="backLink.path"
    [queryParams]="backLink.queryParams"
    class="flex items-center justify-center w-6 h-6 text-3xl mb-3 -ml-2 lg:m-0"
    [attr.aria-label]="'a11y.organizer.edit_activity.listing.back' | translate"
  >
    <vtmn-play-icon [name]="iconType?.ArrowLeft"></vtmn-play-icon>
  </a>

  <app-tips
    class="col-span-12 mb-3 lg:col-span-5 lg:col-start-8 lg:row-start-1 lg:row-end-3"
    [title]="'organizer.edit_activity.listing.tips.title' | translate"
    [tips]="'organizer.edit_activity.listing.tips.text' | translate"
    [icon]="iconType.WarningError"
    [variant]="tipsVariant.WARNING"
  ></app-tips>

  <div class="col-span-12 lg:col-span-5 lg:col-start-2">
    <app-organizer-activity-edition-list
      [title]="'organizer.edit_activity.listing_typology.title' | translate"
      [links]="activityTypologyLinks"
    >
    </app-organizer-activity-edition-list>

    <app-divider></app-divider>

    <app-organizer-activity-edition-list
      [title]="'organizer.edit_activity.listing_details.title' | translate"
      [links]="activityDetailsLinks"
    >
    </app-organizer-activity-edition-list>

    <app-divider></app-divider>

    <app-organizer-activity-edition-list
      [title]="'organizer.edit_activity.listing_parameters.title' | translate"
      [links]="activityParametersLinks"
    >
    </app-organizer-activity-edition-list>
  </div>

  <app-modal #confirmationModal (modalClose)="confirmationModal.hide()">
    <ng-container modal-header>
      {{ 'organizer.edit_activity.confirmation_modal.header' | translate }}
    </ng-container>

    <p modal-content>
      {{ 'organizer.edit_activity.confirmation_modal.content' | translate }}
    </p>

    <div modal-footer class="flex justify-center items-center">
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="confirmationModal.hide()"
      >
        {{ 'organizer.edit_activity.confirmation_modal.cancel' | translate }}
      </button>
      <a
        app-vtmn-play-button
        class="ml-2"
        [variant]="vtmnPlayButtonVariant.NEGATIVE"
        [shape]="vtmnPlayButtonShape.SQUARED"
        [routerLink]="backLink.path"
        [queryParams]="backLink.queryParams"
      >
        {{ 'organizer.edit_activity.confirmation_modal.quit' | translate }}
      </a>
    </div>
  </app-modal>
</app-organizer-shared-layout-dashboard>
